import React from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

const outer = {
  minHeight: '100vh', background: '#f1f5f9', display: 'flex',
  alignItems: 'flex-start', justifyContent: 'center', padding: '48px 16px',
};
const card = {
  width: '100%', maxWidth: 380, background: '#fff', borderRadius: 14,
  boxShadow: '0 10px 40px rgba(0,0,0,0.08)', padding: 28, textAlign: 'center',
};

// Landed on after AblePay's hosted-redirect flow completes — webhooks.js's
// /ablepay/return 303-redirects here with ?payment=success|failed&receipt=&message= in
// the query string (same shape CustomerRenewPage.js already reads for the authenticated
// portal flow), or navigated to client-side after a public Razorpay verify succeeds.
export default function PayBillResultPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const success = searchParams.get('payment') === 'success';
  const receipt = searchParams.get('receipt');
  const message = searchParams.get('message');

  return (
    <div style={outer}>
      <div style={card}>
        {success ? (
          <>
            <CheckCircle size={48} color="#16a34a" style={{ marginBottom: 12 }} />
            <h2 style={{ margin: '0 0 8px', fontSize: '1.1rem' }}>Payment Successful</h2>
            {receipt && <p style={{ color: '#6b7280', fontSize: '.9rem' }}>Receipt: {receipt}</p>}
          </>
        ) : (
          <>
            <XCircle size={48} color="#dc2626" style={{ marginBottom: 12 }} />
            <h2 style={{ margin: '0 0 8px', fontSize: '1.1rem' }}>Payment Failed</h2>
            <p style={{ color: '#6b7280', fontSize: '.9rem' }}>{message || 'Please try again.'}</p>
          </>
        )}
        <Link to={`/pay/${token}`} style={{ display: 'inline-block', marginTop: 16, fontSize: '.9rem' }}>
          Back to payment page
        </Link>
      </div>
    </div>
  );
}
